<template>
  <div
    class="account-avatar"
    :style="{
      '--size': `${size}px`,
    }"
  >
    {{ initials }}
  </div>
</template>

<script setup>
defineProps({
  initials: {
    type: String,
    default: null,
  },
  size: {
    type: Number,
    default: 32,
  },
});
</script>

<style scoped>
.account-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);

  background-color: var(--blue);
  color: var(--white);
  border-radius: 50%;
  font-weight: 700;
  text-transform: uppercase;
  font-size: calc(var(--size) * 0.4)
}
</style>
